import { jsx as t } from "react/jsx-runtime";
import { useState as d, useCallback as f } from "react";
import { Image as g } from "../Image/index.js";
import { FigureContainer as p } from "./styles.js";
import { zoomFilters as v } from "./zoom.js";
function b({ src: o, className: a, ...n }) {
  const [e, m] = d(!1), { addZoom: s, moveZoom: i, clear: l } = v(), r = (c) => e || !o ? void 0 : c, u = f(() => {
    m(!0);
  }, []);
  return /* @__PURE__ */ t(
    p,
    {
      "data-testid": "image-zoom",
      className: a,
      style: { backgroundImage: `url(${o})` },
      "aria-invalid": e,
      onMouseMove: r(i),
      onClick: r(s),
      onMouseLeave: l,
      onSelect: () => !1,
      unselectable: "on",
      children: /* @__PURE__ */ t(g, { src: o, ...n, onError: u })
    }
  );
}
export {
  b as ImageZoom,
  v as zoomFilters
};
